import { render, staticRenderFns } from "./User.vue?vue&type=template&id=64c7206c&scoped=true&"
import script from "./User.vue?vue&type=script&lang=js&"
export * from "./User.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c7206c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/wnytoys/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c7206c')) {
      api.createRecord('64c7206c', component.options)
    } else {
      api.reload('64c7206c', component.options)
    }
    module.hot.accept("./User.vue?vue&type=template&id=64c7206c&scoped=true&", function () {
      api.rerender('64c7206c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/app/components/user/User.vue"
export default component.exports